import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { AuthenticationService } from "app/core/services/authentication.service";
import { TranslateConfigService } from "app/core/services/translate-config.service";
import { StorageDetails } from "app/core/services/user-details.service";
import { RefreshTokenResponse } from "app/entities/refresh-token.model";
import { filter, Subject, switchMap, takeUntil, timer } from "rxjs";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit, OnDestroy {
  private userDetails = inject(StorageDetails);
  private translate = inject(TranslateConfigService);
  private authService = inject(AuthenticationService);

  private destroy$ = new Subject<boolean>();

  ngOnInit() {
    this.translate.setLanguage(this.userDetails.getLanguage());
    this.authRefreshToken(Number(this.userDetails.getJwtvalidityUsers()));
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private authRefreshToken(jwtvalidityUsers: number) {
    if (!isNaN(jwtvalidityUsers) && jwtvalidityUsers) {
      const refreshTime = (jwtvalidityUsers / 2) * 1000;
      timer(refreshTime, refreshTime)
        .pipe(
          filter(() => 'OAUTH2' !== localStorage.getItem("AuthenticationMode")),
          switchMap(() => this.authService.authRefreshToken()),
          takeUntil(this.destroy$),
        )
        .subscribe({
          error: (err) => {
            console.error("Refresh token failed");
            console.error(err);
          },
        });
    } else {
      console.error(
        "jwtvalidityUsers is not a valid number, stored value is: " +
          this.userDetails.getJwtvalidityUsers(),
      );
    }
  }

  protected onActivate() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
}
